import { useMemo } from 'react';
import { useEntityActions } from '@hooks/useEntityActions';
import { useDeleteConditionLookupMutation, type ConditionLookup } from '../api';

export type ConditionAction = 'view' | 'edit' | 'delete' | 'manage_groups';

// Define getEntityId outside to ensure stability
const getEntityId = (condition: ConditionLookup) => condition.id;

// Define additional actions config outside hook for stability
const ADDITIONAL_ACTIONS = {
  manage_groups: 'groups', // Maps to navigateToModal(id, 'groups')
};

export const useConditionActions = () => {

  const entityActions = useEntityActions<ConditionLookup, ConditionAction>({
    entityName: 'condition',
    displayProperty: 'name',
    deleteMutation: useDeleteConditionLookupMutation,
    getEntityId,
    additionalActions: ADDITIONAL_ACTIONS,
  });

  return useMemo(() => entityActions, [entityActions]);
}; 